import { render } from "./ItemEditor.vue?vue&type=template&id=b2a5b9dc&scoped=true"
import script from "./ItemEditor.vue?vue&type=script&lang=js"
export * from "./ItemEditor.vue?vue&type=script&lang=js"

import "./ItemEditor.vue?vue&type=style&index=0&id=b2a5b9dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a5b9dc"]])

export default __exports__